module.exports = __webpack_public_path__ + "static/img/132.eccb4b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/132.png
// module id = KO0f
// module chunks = 0